import { Input } from "design-react-kit";

function InterventoCentroFamigliaComponent({
  setFormData,
  formData,
  errorCheck,
}) {
  const handleChangeCentroFamiglia = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      CentroFamigliaRequest: {
        ...prevData.CentroFamigliaRequest,
        [name]: value,
      },
    }));
  };

  return (
    <div className="row">
      <div className="col-6 mt-3">
        <Input
          label="Progetto*"
          id="progetto"
          name="progetto"
          value={formData?.CentroFamigliaRequest?.progetto}
          onChange={handleChangeCentroFamiglia}
        />
        {errorCheck && !formData?.CentroFamigliaRequest?.progetto && (
          <div className="text-danger mt-n3">Campo Obbligatorio.</div>
        )}
      </div>
      <div className="col-6 mt-3">
        <Input
          label="Provvedimento*"
          id="provvedimento"
          name="provvedimento"
          value={formData?.CentroFamigliaRequest?.provvedimento}
          onChange={handleChangeCentroFamiglia}
        />
        {errorCheck && !formData?.CentroFamigliaRequest?.provvedimento && (
          <div className="text-danger mt-n3">Campo Obbligatorio.</div>
        )}
      </div>
      <div className="col-3"></div>
      <div className="col-6 mt-3">
        <Input
          label="Intervento*"
          id="intervento"
          name="intervento"
          value={formData?.CentroFamigliaRequest?.intervento}
          onChange={handleChangeCentroFamiglia}
        />
        {errorCheck && !formData?.CentroFamigliaRequest?.intervento && (
          <div className="text-danger mt-n3">Campo Obbligatorio.</div>
        )}
      </div>
      <div className="col-6">
        <div className="mb-3">
          <label htmlFor="enteDisposzione" className="form-label">
            Autorità giudiziaria competente*
          </label>
          <select
            id="enteDisposzione"
            name="enteDisposzione"
            className="form-control border"
            value={formData?.CentroFamigliaRequest?.enteDisposzione || ""}
            onChange={handleChangeCentroFamiglia}
            required
          >
            <option value="">Seleziona...</option>
            <option value="Tribunale per i Minori">
              Tribunale per i Minori
            </option>
            <option value="Tribunale Civile">Tribunale Civile</option>
            <option value="Procura">Procura</option>
            <option value="Altro">Altro</option>
          </select>
          {errorCheck && !formData?.CentroFamigliaRequest?.enteDisposzione && (
            <div className="text-danger">Campo Obbligatorio.</div>
          )}
        </div>

        {formData?.CentroFamigliaRequest?.enteDisposzione === "Altro" && (
          <div className="mt-4">
            <Input
              label="Specifica altra autorità*"
              id="enteDisposzioneAltro"
              name="enteDisposzioneAltro"
              value={
                formData?.CentroFamigliaRequest?.enteDisposzioneAltro || ""
              }
              onChange={handleChangeCentroFamiglia}
              required
            />
            <small className="form-text text-muted mt-n3">
              Inserisci il nome dell’autorità giudiziaria, specificando se è
              Ente, Istituzione o Associazione.
            </small>

            {errorCheck &&
              !formData?.CentroFamigliaRequest?.enteDisposzioneAltro && (
                <div className="text-danger">Campo Obbligatorio.</div>
              )}
          </div>
        )}
      </div>
      <div className="col-6">
        <div className="mb-3">
          <label htmlFor="titoloServizio" className="form-label">
            Servizio*
          </label>
          <select
            id="titoloServizio"
            name="titoloServizio"
            className="form-control border"
            value={formData?.CentroFamigliaRequest?.titoloServizio || ""}
            onChange={handleChangeCentroFamiglia}
            required
          >
            <option value="">Seleziona...</option>
            <option value="Sostegno alla genitorialità">
              Sostegno alla genitorialità
            </option>
            <option value="Percorso di Mediazione Familiare">
              Percorso di Mediazione Familiare
            </option>
            <option value="Percorso di Mediazione Culturale">
              Percorso di Mediazione Culturale
            </option>
            <option value="Spazio Neutro">Spazio Neutro</option>
            <option value="Tutela Minori">Tutela Minori</option>
            <option value="Consulenza psicologica">
              Consulenza psicologica
            </option>
            <option value="Altro">Altro</option>
          </select>

          {errorCheck && !formData?.CentroFamigliaRequest?.titoloServizio && (
            <div className="text-danger">Campo Obbligatorio.</div>
          )}
        </div>

        {formData?.CentroFamigliaRequest?.titoloServizio === "Altro" && (
          <div className="mt-4">
            <Input
              label="Specifica altro servizio*"
              id="titoloServizioAltro"
              name="titoloServizioAltro"
              value={formData?.CentroFamigliaRequest?.titoloServizioAltro || ""}
              onChange={handleChangeCentroFamiglia}
              required
            />

            {errorCheck &&
              !formData?.CentroFamigliaRequest?.titoloServizioAltro && (
                <div className="text-danger mt-n3">Campo Obbligatorio.</div>
              )}
          </div>
        )}
      </div>
    </div>
  );
}

export default InterventoCentroFamigliaComponent;
